var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditButtonLightBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3439_31231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7674 14.551C18.5473 14.551 18.3689 14.7294 18.3689 14.9495V18.4876C18.3681 19.1475 17.8334 19.6824 17.1734 19.683H5.99241C5.33243 19.6824 4.79774 19.1475 4.79697 18.4876V8.1035C4.79774 7.44367 5.33243 6.90883 5.99241 6.90805H9.53051C9.75061 6.90805 9.92899 6.72967 9.92899 6.50957C9.92899 6.28962 9.75061 6.11108 9.53051 6.11108H5.99241C4.89254 6.11233 4.00125 7.00362 4 8.1035V18.4877C4.00125 19.5876 4.89254 20.4789 5.99241 20.4801H17.1734C18.2733 20.4789 19.1646 19.5876 19.1659 18.4877V14.9495C19.1659 14.7294 18.9875 14.551 18.7674 14.551Z",
    fill: "url(#paint0_linear_3439_31231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0084 5.08577C18.3081 4.38547 17.1727 4.38547 16.4724 5.08577L9.36321 12.195C9.31449 12.2437 9.27931 12.3041 9.26094 12.3704L8.32606 15.7455C8.28762 15.8839 8.32669 16.0321 8.42818 16.1337C8.52982 16.2352 8.67801 16.2743 8.81639 16.236L12.1915 15.3009C12.2578 15.2826 12.3182 15.2474 12.3669 15.1987L19.476 8.08934C20.1752 7.38857 20.1752 6.25414 19.476 5.55337L19.0084 5.08577ZM10.2315 12.454L16.0498 6.6355L17.9262 8.51195L12.1078 14.3304L10.2315 12.454ZM9.85664 13.2061L11.3558 14.7054L9.28211 15.2799L9.85664 13.2061ZM18.9125 7.52586L18.4899 7.94847L16.6133 6.07186L17.036 5.64925C17.425 5.26027 18.0557 5.26027 18.4447 5.64925L18.9125 6.11685C19.3008 6.5063 19.3008 7.13656 18.9125 7.52586Z",
    fill: "url(#paint1_linear_3439_31231)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3439_31231",
    x1: 11.5829,
    y1: 4.47095,
    x2: 11.5829,
    y2: 21.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3439_31231",
    x1: 14.1559,
    y1: 4.47095,
    x2: 14.1559,
    y2: 21.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3439_31231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButtonLightBlue);
export default __webpack_public_path__ + "static/media/editButtonLightBlue.5d55d9a2251125c42e13fe3f37fdc2c8.svg";
export { ForwardRef as ReactComponent };